import { render, staticRenderFns } from "./CardTraceability.vue?vue&type=template&id=401dd18c&scoped=true"
import script from "./CardTraceability.vue?vue&type=script&lang=js"
export * from "./CardTraceability.vue?vue&type=script&lang=js"
import style0 from "./CardTraceability.vue?vue&type=style&index=0&id=401dd18c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401dd18c",
  null
  
)

export default component.exports